/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { combineReducers } from 'redux'

import dashboardReducer from '../../containers/Dashboard/reducer'

import globalReducer from './global'
import alertsReducer from './alerts'
import sdManagerReducer from './sdManager'
import locationManagerReducer from './locationManager'
import growthbookReducer from './growthbook'
/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer(asyncReducers) {
  return combineReducers({
    global: globalReducer,
    alerts: alertsReducer,
    dashboard: dashboardReducer,
    sdManager: sdManagerReducer,
    locationManager: locationManagerReducer,
    growthbook: growthbookReducer,
    ...asyncReducers,
  })
}
